export function getLocation () {
  if (window.location.host.match(/^tw\.dimorder\.com/)) {
    return 'TW'
  } else {
    return 'HK'
  }
}



// WEBPACK FOOTER //
// ./src/helpers/location.js